import { useState } from 'react';
import { apiFetch } from '../config/api';

export default function SendStaffOnboardingEmailButton({
  token,
  staffId,
  schoolId,
  hasPassword = false,
}) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (hasPassword && !window.confirm('This staff member is already onboarded. Send the onboarding email anyway?')) {
      return;
    }

    setSending(true);
    setSent(false);
    setError('');

    try {
      await apiFetch(`/staff/${staffId}/onboarding-email`, {
        method: 'POST',
        body: JSON.stringify({ school_id: schoolId, force: hasPassword }),
      }, token);
      setSent(true);
    } catch (err) {
      setError(err.message || 'Could not send staff onboarding email.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <button
        type="button"
        className="sa-btn sa-btn-secondary"
        onClick={handleSend}
        disabled={sending || sent || !staffId || !schoolId}
      >
        {sending ? 'Sending...' : sent ? 'Email Sent' : 'Send Onboarding Email'}
      </button>
      {error ? <span style={{ color: '#991b1b', fontSize: 12 }}>{error}</span> : null}
    </div>
  );
}
